const getDefaultState = () => ({
  xmlProducts: {
    items: [],
    itemsLoading: false,
    itemsError: false,
  },
  xmlChannels: {
    items: [],
    itemsLoading: false,
    itemsError: false,
  },
  brands: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    selectedBrands: undefined,
  },
  salesStats: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/twenty/defaultState.js